import { render, staticRenderFns } from "./AddBlockedPagkage.vue?vue&type=template&id=79cdc4b4&"
import script from "./AddBlockedPagkage.vue?vue&type=script&lang=js&"
export * from "./AddBlockedPagkage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports